import { coreApi } from '../../../api'

async function fetchCreditReference(id) {
  const { data: response } = await coreApi.get(
    `/underwriting/auto-refi/fidc/applications/${id}/credit-reference`,
  )

  return {
    id: response.data.id,
  }
}

export { fetchCreditReference }
